import { NgModule } from '@angular/core';
import { provideTranslocoScope } from '@ngneat/transloco';
import { provideTranslationMarkupTranspiler } from 'ngx-transloco-markup';
import { MARKETPLACE_TRANSLOCO_SCOPE } from '../marketplace-transloco-scope';
import { SubscriptionIntervalTranspiler } from './subscription-interval-transpiler';
import { SubscriptionPriceUpdateService } from './subscription-price-update.service';

@NgModule({
  providers: [
    provideTranslationMarkupTranspiler(SubscriptionIntervalTranspiler),
    provideTranslocoScope(MARKETPLACE_TRANSLOCO_SCOPE),
    SubscriptionPriceUpdateService
  ]
})
export class SubscriptionPriceUpdateModule {}
